import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppAuthService } from '../auth/app-auth-service';

export const authGuard: CanActivateFn = (_route, _state): Observable<boolean> => {
  const authService = inject(AppAuthService);

  return authService.canLogin().pipe(
    map((canLogin) => {
      if (canLogin) {
        return true;
      } else {
        authService.logout();
        return false;
      }
    }),
    catchError(() => {
      authService.logout();
      return of(false);
    })
  );
};
